import { RemoveLicenseContainer } from "../Licenses/Modals/RemoveContainer";
import { LicenseRemovedBottomSheet } from "../Licenses/Modals/RemovedBottomSheet";
import { RenewInstructionsContainer } from "../Licenses/Modals/RenewInstructionsContainer";
import { ModalRoute } from "../Navigation/ModalRoute";
import { ModalTransitionSwitch } from "../Navigation/ModalTransitionSwitch";
import {
  LICENSE_REMOVED_MODAL_PATH,
  REMOVE_LICENSE_MODAL_PATH,
  REMOVE_ROLE_MODAL_PATH,
  RENEW_LICENSE_MODAL_PATH,
  ROLE_REMOVED_MODAL_PATH,
} from "./paths";
import { RemoveRoleModalContainer } from "./RoleDetails/Remove/RemoveContainer";
import { RoleRemovedBottomSheetContainer } from "./RoleDetails/Remove/RemovedContainer";

interface RoleModalRoutesProps {
  basePath: string;
  rolesPath: string;
}

export function RoleModalRoutes(props: RoleModalRoutesProps) {
  const { basePath, rolesPath } = props;

  return (
    <ModalTransitionSwitch>
      <ModalRoute
        shouldReplacePathOnBack
        closeModalPath={basePath}
        path={`${basePath}/${REMOVE_ROLE_MODAL_PATH}`}
        render={({ modalState }) => {
          return <RemoveRoleModalContainer modalState={modalState} rolesPath={rolesPath} />;
        }}
      />

      <ModalRoute
        shouldReplacePathOnBack
        closeModalPath={basePath}
        path={`${basePath}/${ROLE_REMOVED_MODAL_PATH}`}
        render={({ modalState }) => {
          return <RoleRemovedBottomSheetContainer modalState={modalState} />;
        }}
      />

      <ModalRoute
        shouldReplacePathOnBack
        closeModalPath={basePath}
        path={`${basePath}/${REMOVE_LICENSE_MODAL_PATH}`}
        render={({ modalState }) => {
          return <RemoveLicenseContainer modalState={modalState} basePath={basePath} />;
        }}
      />

      <ModalRoute
        shouldReplacePathOnBack
        closeModalPath={basePath}
        path={`${basePath}/${RENEW_LICENSE_MODAL_PATH}`}
        render={({ modalState }) => {
          return <RenewInstructionsContainer modalState={modalState} />;
        }}
      />

      <ModalRoute
        shouldReplacePathOnBack
        closeModalPath={basePath}
        path={`${basePath}/${LICENSE_REMOVED_MODAL_PATH}`}
        render={({ modalState }) => {
          return <LicenseRemovedBottomSheet modalState={modalState} />;
        }}
      />
    </ModalTransitionSwitch>
  );
}
